import apiClient from "../../../service/apiClient";
import { HOME_ENDPOINTS } from "../../../app/apiEndpoints";

export const fetchHomeLinks = () => {
  return apiClient.get(HOME_ENDPOINTS.HOME_LINKS);
};
